export const GET_MESSAGES = "GET_MESSAGES";
export const GET_SENT_MESSAGES = "GET_SENT_MESSAGES";
export const GET_THREAD = "GET_THREAD";
export const GET_SELECTEDMSG = "GET_SELECTEDMSG";
export const GET_ATTACHMENTS = "GET_ATTACHMENTS";
export const GET_TO_USERS = "GET_TO_USERS";
